import RegistroForm from '../components/RegistroForm';

export default function RegistroToner() {
  return (
    <div className="ml-0 lg:ml-72 p-4 sm:p-6 pt-16 lg:pt-6 min-h-screen">
      <RegistroForm />
    </div>
  );
}
